<template>
  <div class="order-detail" ref="orderDetail">
    <div class="input-box">
      <span>我的订单</span>
      <div class="box">
        <input
          type="text"
          placeholder="商品名称/订单编号"
          v-model="params.search"
        />
        <span class="btn" @click="goToSearch">搜索</span>
      </div>
    </div>
    <Menu
      mode="horizontal"
      :theme="theme1"
      active-name="-1"
      v-if="userInfo.orderStatusNum"
      @on-select="changeMenu"
      ref="menu"
    >
      <MenuItem name="-1">
        全部订单
      </MenuItem>
      <MenuItem name="5">
        待审核
      </MenuItem>
      <MenuItem name="0">
        待付款
      </MenuItem>
      <MenuItem name="1">
        待发货
      </MenuItem>
      <MenuItem name="2">
        待收货
      </MenuItem>
      <MenuItem name="3">
        待评价
      </MenuItem>
      <MenuItem name="4">
        售后/退款
      </MenuItem>
    </Menu>
    <div class="order-title">
      <span>所有时间</span>
      <span>订单详情</span>
      <span>收货人</span>
      <span>金额</span>
      <span>状态</span>
      <span>操作</span>
    </div>
    <div class="content" v-if="orderList.length > 0">
      <div class="item" v-for="item of orderList" :key="item.id">
        <div class="item-title">
          <div class="item-title--time">{{ item._add_time }}</div>
          <div class="item-title--num">
            订单号：<span>{{ item.order_id }}</span>
          </div>
        </div>
        <div class="item-content">
          <div class="item-content--header">
            <div class="product-num" v-for="val of item.cartInfo" :key="val.id">
              <div class="img" @click="goToDetail(val.id)">
                <img :src="val.productInfo.image" alt="" />
              </div>
              <div class="name" @click="goToDetail(val.id)">
                {{ val.productInfo.store_name }}
              </div>
              <div class="number">x{{ val.cart_num }}</div>
            </div>
          </div>
          <div class="item-content--name">{{ item.real_name }}</div>
          <div class="item-content--money">
            <div class="total">总额 ¥{{ item.pay_price }}元</div>
            <div class="tip">（含运费：￥{{ item.pay_postage }}）</div>
            <div class="pay-type">{{ item._status._payType }}</div>
          </div>
          <div class="item-content--pay">
            <div>{{ item._status._title }}</div>
            <div @click="goBuy(item.order_id)">订单详情</div>
          </div>
          <div class="item-content--btn">
            <template v-if="params.type === '0'">
              <template v-if="item._status._type === 9">
                <div @click="goBuy(item.order_id)">{{ item._status._msg }}</div>
              </template>
              <template v-else>
                <div v-if="item.isAgree === 0" @click="goBuy(item.order_id)">
                  处方审核中
                </div>
                <div
                  v-else-if="item.isAgree === 1"
                  @click="goBuy(item.order_id)"
                >
                  立即付款
                </div>
                <div v-else @click="goBuy(item.order_id)">未通过，查看原因</div>
              </template>
            </template>
            <template v-else>
              <div @click="goBuy(item.order_id)">查看</div>
            </template>
          </div>
        </div>
      </div>
      <Spin size="large" fix v-if="loading"></Spin>
    </div>
    <div class="content" v-else>
      <div class="item-none">
        <div class="img">
          <img src="@assets/pc/images/home/none.png" alt="" />
        </div>
        <div class="tip">
          暂无订单，这就去
          <span>
            <router-link to="/">商城首页</router-link>
          </span>
          挑选商品！
        </div>
      </div>
    </div>
    <div class="page-size" v-if="totalNum && totalNum > 10">
      <Page
        :total="totalNum"
        show-sizer
        @on-change="changePage"
        :page-size="10"
        :page-size-opts="[10]"
        :current="params.page"
      ></Page>
    </div>
  </div>
</template>

<script>
import { getUser } from "@api/user";
import { getOrderList } from "@api/order";
export default {
  name: "MyOrder",
  data() {
    return {
      theme1: "light",
      userInfo: {},
      params: {
        page: 1,
        limit: 10,
        type: "",
        search: ""
      },
      orderList: [],
      totalNum: 0,
      loading: false
    };
  },
  created() {
    getUser()
      .then(res => {
        this.userInfo = res.data;
        let currentActive =
          Object.keys(this.$route.query).length > 0
            ? this.$route.query.active
            : "";
        if (currentActive === "0") {
          this.$nextTick(() => {
            this.$refs.menu.currentActiveName = "0";
          });
        }
      })
      .catch(err => {
        console.log(err.msg);
      });
    this.getProdectList();
  },
  methods: {
    changePage(index) {
      this.params.page = index;
      this.getProdectList();
    },
    getProdectList() {
      this.loading = true;
      getOrderList(this.params)
        .then(res => {
          this.orderList = res.data;
          this.totalNum = Number(res.msg);
        })
        .catch(err => {
          if (err.msg === "系统出现异常") {
            this.$router.go(0);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeMenu(name) {
      this.params.search = "";
      if (name === "-1") {
        this.params.type = "";
      } else {
        this.params.type = name;
      }
      this.params.page = 1;
      this.getProdectList();
    },
    goBuy(id) {
      this.$router.push({
        path: "/home/orderDetail/" + id
      });
    },
    goToSearch() {
      this.getProdectList();
      this.$nextTick(() => {
        this.$refs.menu.currentActiveName = "-1";
      });
    },
    goToDetail(id) {
      this.$router.push({
        url: "/detail/" + id
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.order-detail /deep/ .ivu-menu
  border 1px solid #e0e0e0
  border-bottom 0
  height 40px
  line-height 40px
  .ivu-menu-item-active
    font-weight 700

.input-box
  display flex
  line-height 56px
  height 56px
  >span
    font-size 18px
  .box
    margin-left 30px
    input
      width 170px
      padding 12px 8px
      border 1px solid #ccc
      height 15px
      line-height 15px
      font-size 12px
    .btn
      width 60px
      height 26px
      line-height 24px
      border-radius 0px 2px 2px 0px
      display inline-block
      margin-left -1px
      text-align center
      background #4496ee
      border 1px solid #4496ee
      color #FFF
      font-size 14px
      cursor pointer

.order-title
  height 34px
  line-height 34px
  background #f5f5f5
  font-size 12px
  color #666666
  font-family 'Microsoft yahei'
  display flex
  width 100%
  margin-top 20px
  text-align center
  span
    &:nth-child(1)
      width 140px
    &:nth-child(2)
      width 280px
    &:nth-child(3)
      width 90px
    &:nth-child(4)
      width 200px
    &:nth-child(5)
      width 100px
    &:nth-child(6)
      flex 1

.content
  margin-top 20px
  margin-bottom 30px
  position relative
  .item
    margin-top 20px
    border 1px solid #f5f5f5
    &-title
      line-height 34px
      background #f5f5f5
      display flex
      color #aaa
      &--time
        padding 0 30px 0 15px
      &--num
        font-family '宋体'
        span
          color #333
          font-family 'Microsoft yahei'
    &-content
      display flex
      font-size 13px
      &--header
        width 420px
        border-right 1px solid #f5f5f5
        .product-num
          display flex
          padding 20px 0
          border-bottom 1px solid #f5f5f5
          &:last-child
            border-bottom 0
          .img
            cursor pointer
            width 68px
            height 68px
            border 1px solid #f5f5f5
            align-self center
            margin 0 15px
            img
              width 100%
              height 100%
          .name
            cursor pointer
            width 200px
            margin-top 15px
            margin-right 60px
            height 36px
            color #555
            display -webkit-box !important
            overflow hidden
            text-overflow ellipsis
            word-break break-all
            -webkit-box-orient vertical
            -webkit-line-clamp 2
            &:hover
              color #4496ee
          .number
            margin-top 15px
            font-family 'Microsoft yahei'
            color #aaa
      &--name
        width 90px
        text-align center
        padding-top 30px
        color #555
        border-right 1px solid #f5f5f5
      &--money
        width 200px
        padding-top 30px
        text-align center
        border-right 1px solid #f5f5f5
        color #555
        .total
          margin-bottom 10px
        .tip
        .pay-type
          color #9b9b9b
          font-size 12px
      &--pay
        color #555
        padding-top 30px
        width 100px
        border-right 1px solid #f5f5f5
        text-align center
        div:first-child
          margin-bottom 10px
          color #9b9b9b
        div:last-child
          cursor pointer
      &--btn
        padding-top 30px
        margin 0 auto
        div
          cursor pointer
          text-align center
          padding 0 5px
          height 22px
          line-height 22px
          background #4889f6
          color #fff
          border-radius 2px
          font-family '宋体'
          min-width 62px
  .item-none
    min-height 150px
    .img
      margin 100px auto 20px
      width 80px
      height 50px
      img
        width 100%
        height 100%
    .tip
      text-align center
      color #aaa
      span
        color #1880f4
</style>
<style scoped>
.page-size {
  margin: 15px 0px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
